import styled from 'styled-components'

import { ThemeModeType } from '@application/Types/ComponentTypes'

export const Title = styled.p`
    ${(props) => props.theme.typo.displayXL};
    ${(props) => props.theme.fontWeight.light};
    margin-bottom: 15px;

    @media ${(props) => props.theme.query.min.tablet} {
        ${(props) => props.theme.typo.displayXXL};
        margin-bottom: 10px;
    }
`

export const Value = styled.h3`
    ${(props) => props.theme.typo.displayM};
    ${(props) => props.theme.fontWeight.medium};
    text-transform: uppercase;
`

export const Wrapper = styled.div<{ $mode: ThemeModeType }>`
    padding: 100px 20px;
    background-color: ${(props) => props.theme.color[props.$mode === 'Dark' ? 'p600' : 'g100']};

    ${Title}, ${Value} {
        color: ${(props) => props.theme.color[props.$mode === 'Dark' ? 'white' : 'p500']};
    }

    @media ${(props) => props.theme.query.min.tablet} {
        padding-left: 0px;
        padding-right: 0px;
    }
`
